import confetti from 'canvas-confetti';

// Reads a design token (e.g. "--primary" -> "18 92% 52%") and returns an hsl() color
// string so confetti matches the active theme (light / dark / etc.).
function token(name, fallback) {
  try {
    const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
    return v ? `hsl(${v})` : fallback;
  } catch (e) {
    return fallback;
  }
}

// A short, tasteful two-burst confetti pop in the app's warm brand palette.
// Respects prefers-reduced-motion (no-op) so it never overwhelms.
export function celebrate() {
  if (typeof window === 'undefined') return;
  try {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  } catch (e) { /* ignore */ }

  const colors = [
    token('--brand-apricot', '#f2732a'),
    token('--brand-honey', '#f5a623'),
    token('--brand-coral', '#f0603f'),
    token('--brand-mint', '#2fb99a'),
  ];
  const defaults = { spread: 70, startVelocity: 38, ticks: 200, zIndex: 400, colors, disableForReducedMotion: true };

  confetti({ ...defaults, particleCount: 60, origin: { x: 0.5, y: 0.35 }, scalar: 0.9 });
  setTimeout(() => confetti({ ...defaults, particleCount: 40, angle: 60, origin: { x: 0, y: 0.6 } }), 120);
  setTimeout(() => confetti({ ...defaults, particleCount: 40, angle: 120, origin: { x: 1, y: 0.6 } }), 120);
}
